import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DataSharingService } from '../../Services/data-sharing.service';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from '../tracking/api-service.service';
import { ShareCsvDialogComponent } from '../../shared/share-csv-dialog/share-csv-dialog.component';
import { MessageDialogComponent } from '../../shared/message-dialog/message-dialog.component';

@Component({
  selector: 'app-tracking-details',
  templateUrl: './tracking-details.component.html',
  styleUrls: ['./tracking-details.component.scss']
})
export class TrackingDetailsComponent implements OnInit {
  panelOpenState = false;
  details: any = {}; // Initialize with an empty object to avoid undefined errors
  setDetaildata: any;
  imageSrc: string = '../../../../assets/Icon/delivery_truck_speed_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg';
  progressValue: number = 33.33;
  latitude: string = '';
  longitude: string = '';
  location: string = '';
  filterForm: FormGroup;
  FIRST_MILE: boolean = true;
  MIDDLE_MILE: boolean = false;
  LAST_MILE: boolean = false;

  constructor(
    private dataSharingService: DataSharingService,
    private router: Router,
    public dialog: MatDialog,
    public fb: FormBuilder,
    private Service: ApiServiceService
  ) {
    this.filterForm = this.fb.group({
      Keyword: ['', [Validators.required]],
      SearchBy: ['']
    });
  }

  ngOnInit(): void {
    const savedData = localStorage.getItem('trackingDetails');
    if (savedData) {
      this.details = JSON.parse(savedData);
      this.extractLocationDetails();
    } else {
      const data = this.dataSharingService.getData();
      if (data) {
        this.details = data;
        localStorage.setItem('trackingDetails', JSON.stringify(data));
        this.extractLocationDetails();
      } else {
        const Url = this.router.url;
        const orderId = Url.split('=')[1];
        this.keywordchanged(orderId);
      }
    }
    this.getProcessBarValue();
  }

  extractLocationDetails(): void {
    if (this.details) {
      this.latitude = this.details['Latitude'] || '';
      this.longitude = this.details['Longitude'] || '';
      this.location = this.details['Location'] || '';
    }
  }

  keywordchanged(keyword: any): void {
    this.filterForm.controls['Keyword'].setValue(keyword);
    if (keyword.includes('xpo') || keyword.includes('xpl')) {
      this.filterForm.controls['SearchBy'].setValue('OrderId');
    } else if (keyword.includes('xpcn')) {
      this.filterForm.controls['SearchBy'].setValue('XPCN');
    } else if (keyword.includes('xpls')) {
      this.filterForm.controls['SearchBy'].setValue('XPLS');
    } else {
      this.filterForm.controls['SearchBy'].setValue('XPCN');
    }
    this.URLForMobile();
  }


  getProcessBarValue(): void {
    const status = this.details?.['StatusOfOrder'] || '';
    if (status.includes('Intransit') || status.includes('Out for Delivery') || status.includes('Arrived at Destination') || status.includes('UnDelivered')) {
      this.MIDDLE_MILE = true;
      this.FIRST_MILE = true;
      this.progressValue = status.includes('Out for Delivery') ? 93 : (status.includes('Arrived at Destination') || status.includes('UnDelivered')) ? 98 : 77;
    } else if (status.includes('Delivered')) {
      this.FIRST_MILE = true;
      this.MIDDLE_MILE = true;
      this.LAST_MILE = true;
      this.progressValue = 100;
    } else {
      this.FIRST_MILE = true;
      this.progressValue = 33.33;
    }
  }

  back(): void {
    this.router.navigate(['/Homepage']);
    localStorage.removeItem('trackingDetails');
  }

  ShareDialog(): void {
    this.dialog.open(ShareCsvDialogComponent, {
      width: '400px',
      data: this.details
    });
  }

  URLForMobile(): void {
    this.Service.getDetails(this.filterForm.value).subscribe((data: any) => {
      if (data['Success'] && data['Data']) {
        this.details = data['Data'];
        this.extractLocationDetails();
        this.dataSharingService.setData(data['Data']);
      }
    });
  }
}
